import { useState, useEffect, useContext } from 'react';
import { AuthContext } from '../../../contexts/AuthContext';

const ROLES = {
  ADMIN: 'ADMIN',
  DATA_MANAGER: 'DATA_MANAGER',
  LOGISTICS_COORDINATOR: 'LOGISTICS_COORDINATOR',
  AREA_COORDINATOR: 'AREA_COORDINATOR',
  CLIENT: 'CLIENT',
};

const PERMISSIONS = {
  CREATE_STOCK: 'STOCK_add',
  EDIT_STOCK: 'STOCK_change',
  DELETE_STOCK: 'STOCK_delete',
  VIEW_STOCK: 'STOCK_view'
};

const ROLE_PERMISSIONS = {
  [ROLES.ADMIN]: [
    PERMISSIONS.CREATE_STOCK,
    PERMISSIONS.EDIT_STOCK,
    PERMISSIONS.DELETE_STOCK,
    PERMISSIONS.VIEW_STOCK
  ],
  [ROLES.DATA_MANAGER]: [
    PERMISSIONS.CREATE_STOCK,
    PERMISSIONS.EDIT_STOCK,
    PERMISSIONS.DELETE_STOCK,
    PERMISSIONS.VIEW_STOCK
  ],
  [ROLES.LOGISTICS_COORDINATOR]: [
    PERMISSIONS.EDIT_STOCK,
    PERMISSIONS.VIEW_STOCK
  ],
  [ROLES.AREA_COORDINATOR]: [
    PERMISSIONS.EDIT_STOCK,
    PERMISSIONS.VIEW_STOCK
  ],
  [ROLES.CLIENT]: [
    PERMISSIONS.VIEW_STOCK
  ]
};

const usePermissions = () => {
  const { user } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const hasPermission = (permission) => {
    if (!user?.role?.name) return false;
    return ROLE_PERMISSIONS[user.role.name]?.includes(permission) || false;
  };

  const can = {
    createStock: () => hasPermission(PERMISSIONS.CREATE_STOCK),
    editStock: () => hasPermission(PERMISSIONS.EDIT_STOCK),
    deleteStock: () => hasPermission(PERMISSIONS.DELETE_STOCK),
    viewStock: () => hasPermission(PERMISSIONS.VIEW_STOCK)
  };

  return {
    loading,
    error,
    can,
    ROLES,
    PERMISSIONS
  };
};

export default usePermissions;
